import { experienceApiClient } from '@/config/httpClients';
import {
  InitialLoginResponseSchema,
  type InitialLoginResponse,
} from '../auth.schemas';

export type LoginWithPostcodeParams = {
  postcode: string;
  email: string;
};

const loginWithPostcode = async ({
  postcode,
  email,
}: LoginWithPostcodeParams) => {
  const response = await experienceApiClient
    .post<InitialLoginResponse>('v1/oauth/token', {
      json: {
        postcode,
        email,
        brand: import.meta.env.VITE_BRAND,
      },
    })
    .json();

  const safeParseResponse = InitialLoginResponseSchema.safeParse(response);
  if (!safeParseResponse.success) {
    //TODO: Log error to Sentry
    console.error(
      'Error validating loginWithPostcode',
      safeParseResponse.error
    );
    //Lie to TS in case of any runtime validation errors
    return response as InitialLoginResponse;
  } else {
    return response;
  }
};

export { loginWithPostcode };
